(function () {

    /** sign up form service **/
    SUGApp.service('signUpFormService', ['SUGUtilities', 'signupPageService', '$q', function(util, signupPageService, $q){

        var service = {};
        // Retrieve cached values from signupPageService
        service.cachedMemberinfo = signupPageService.getMemberInfo();
        //service.cachedSignup = signupPageService.getSignUpInfo();
        //service.cachedTheme = signupPageService.getThemeInfo(); Not needed
        service.cachedThemeClass = signupPageService.getThemeClassInfo();
		service.cachedAttrs = signupPageService.getAttrs();
       
        service.useSinglePageApplication = false;

        service.getSignUpFormAttrs = function( data ){
            // pull first from signupPageService cache
            var cacheObj = signupPageService.getAttrs();
            // if still empty, use local service cache
            if(typeof(cacheObj) !== 'object' || angular.equals(cacheObj, {})) {
                cacheObj = service.cachedAttrs;
            }
            // If the cached object is not empty use it instead of making the XHR request to retrieve the data
            if (typeof(cacheObj) === 'object' && !angular.equals(cacheObj, {})) {
                // Wrap cached data object in dummy XHR request response format so the existing validation code doesn't fail.
                var returnObj = { data: cacheObj, success: true, message: [], code: '' };
                return { data: returnObj, status: 200 };
            } else {
                return util.APISyncCall( "post", "", data, "s.getSignUpFormAttrs", 15000 );
            }
        };

        service.getSignUpTheme = function( data ){
            var cacheObj = service.cachedThemeClass;
            if (typeof(cacheObj) === 'object' && !angular.equals(cacheObj, {})) {
                service.useSinglePageApplication = true;
                // Wrap cached data object in dummy XHR request response format so the existing validation code doesn't fail.
                var returnObj = { data: cacheObj, success: true, message: [], code: '' };
                return { data: returnObj, status: 200 };
            } else {
                return util.APISyncCall( "post", "", data, "s.getSignUpTheme", 15000 );
            }
        };

        service.getSignUpFormItems = function( data ){
            return util.APISyncCall( "post", "", data, "s.getSignUpFormItems", 15000 );
        };

        service.getUserInfo = function( data ){
            var cacheObj = service.cachedMemberinfo;
            // If the cached object is not empty use it instead of making the XHR request to retrieve the data
            if (typeof(cacheObj) === 'object' && !angular.equals(cacheObj, {})) {
                service.useSinglePageApplication = true;
                // Set up promise for returning cached data because that is what the controller is expecting
                var deferred = $q.defer(); 
                // Wrap cached data object in dummy XHR request response format so the existing validation code doesn't fail.
                var returnObj = { data: cacheObj, success: true, message: [], code: '' };
                deferred.resolve({ data: returnObj, status: 200 });
                return deferred.promise;
            } else {
                return util.APISyncCall( "post", "", data, "m.getMemberInfo", 15000 );
            }
        };

        service.getMainNavigation = function(){
            return util.APISyncCall( "post", "", "", "c.getMainNavigation", 15000 );
        };

        service.processSignUp = function( data ){
            return util.APISyncCall( "post", "", data, "s.processSignUpFormHandler", 45000 );
        };

        service.cancelForm = function(){
            // reset attributes to empty
            signupPageService.setAttrs({});
            return util.APISyncCall( "get", "", "", "s.cancelSignUpForm", 15000 );
        };

        service.checkSignUpAds = function( data ){
            return util.APISyncCall( "post", "", data, "s.checkSignUpAds", 45000 );
        };

        service.getCompletedSignUpDetail = function( data ){
            return util.APISyncCall( "post", "", data, "s.getCompletedSignUpDetail", 45000 );
        };

        service.removeSignupTransaction = function( data ){
            return util.APISyncCall( "post", "", data, "s.removeSignupTransaction", 45000 );
        };

        service.completeSignupTransaction = function( data ){
            return util.APISyncCall( "post", "", data, "s.completeSignupTransaction", 45000 );
        };
        
        service.completeWePayPayment = function( data ){
            return util.APISyncCall( "post", "", data, "s.completeWePayPayment", 45000 );
        };

        service.completeLumaPayPayment = function( data ){
            return util.APISyncCall( "post", "", data, "s.completeLumaPayPayment", 15000 );
        };

        service.getMerchantOutage = function (data) {
            return util.APISyncCall('post', '', data, 't.getMerchantOutage', 15000);
        };

        service.resultErrorHandler = function( response ){
    		var Message = "";
    		var result = util.lowerCaseKeys(response);
    		if( angular.isDefined(result.message) ){
    			if( angular.isArray(result.message) ){
                    angular.forEach( result.message, function(obj,key){
                        Message += obj + " ";
                    });
    			} else {
    				Message = result.message;
    			}
    		} else {
    			if( util.isDefinedNotNullNotEmpty(result.statustext) ){
    				Message = result.statustext;
    			} else if( typeof result.status !== undefined && result.status === 0 ){
    				Message = 'Request timeout exceeded. Make sure you are logged in and have an active session.';
    			}
    			else {
    				Message = 'An unknown error occurred while processing your request';
    			}
    		}

    		return Message;
    	};

        return service;

    }]);

})();
